export default "__VITE_ASSET__XDys2vV2__"